import { registerFeatureTranslations } from '@/core/i18n';
import type { TranslationSchema } from '@/core/types/translation.types';
import es from './es.json';
import en from './en.json';

export function registerCustomFieldsTranslations() {
  registerFeatureTranslations<TranslationSchema>('customFields', { es, en });
}
